import { array, type Infer, object, union } from "superstruct";

import { BodyBlockSchema } from "./blocks/body.js";
import { ListItemBlockSchema } from "./blocks/list-item.js";
import { TitleBlockSchema } from "./blocks/title.js";

export const BriefBlockSchema = union([TitleBlockSchema, BodyBlockSchema, ListItemBlockSchema]);
export const BriefBlocksSchema = array(BriefBlockSchema);
export const BriefSchema = object({ blocks: BriefBlocksSchema });

export type BriefBlock = Infer<typeof BriefBlockSchema>;
export type BriefBlocks = Infer<typeof BriefBlocksSchema>;
export type BriefBlockType = BriefBlock["type"];
export type Brief = Infer<typeof BriefSchema>;
